import { SvgProps } from "../../types";

const Location = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={18}
    fill="none"
    viewBox="0 0 16 20"
    {...props}
  >
    <path
      fill={props.fill ? props.fill : "#1064ED"}
      d="M8.429 9.5c.55 0 1.02-.176 1.412-.529.392-.352.588-.776.588-1.271 0-.495-.196-.919-.588-1.271A2.038 2.038 0 0 0 8.43 5.9c-.55 0-1.021.176-1.413.529-.391.352-.587.776-.587 1.271 0 .495.196.919.587 1.271.392.353.863.529 1.413.529Zm0 6.615c2.033-1.68 3.541-3.206 4.525-4.579.983-1.372 1.475-2.591 1.475-3.656 0-1.635-.58-2.974-1.738-4.016C11.533 2.82 10.112 2.3 8.43 2.3c-1.684 0-3.104.521-4.263 1.564C3.008 4.906 2.43 6.245 2.43 7.88c0 1.065.492 2.284 1.475 3.656.983 1.373 2.492 2.899 4.525 4.579Zm0 2.385c-2.684-2.055-4.688-3.964-6.013-5.726C1.091 11.01.43 9.38.43 7.88c0-2.25.804-4.043 2.412-5.377C4.45 1.167 6.312.5 8.43.5s3.979.667 5.587 2.002C15.625 3.838 16.43 5.63 16.43 7.88c0 1.5-.663 3.131-1.988 4.894-1.325 1.762-3.329 3.671-6.012 5.726Z"
    />
  </svg>
);
export default Location;
